import UnitResources from './component';

import _routes from './routes';

export const routes = _routes;

export default UnitResources;



// WEBPACK FOOTER //
// ./containers/Group/UnitResources/index.js